import React from "react"
import { ProgressBar } from "gatsby-interface"
import PropTypes from "prop-types"
import { hideOnMobileCss } from "@modules/ui/utils/responsive"

const progressBarLabelled = _theme => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  flex: 1,
})

const progressBarCss = theme => ({
  width: "50px",
  marginRight: theme.space[3],
})

const textCss = theme => ({
  fontSize: theme.fontSizes[0],
  color: theme.colors.grey[60],
  strong: {
    color: theme.colors.black,
    fontWeight: theme.fontWeights.semiBold,
  },
  display: "inline-flex",
})

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
}

export function LabelledProgressBar({ max, value, id, children }) {
  return (
    <div css={progressBarLabelled}>
      <div css={theme => [progressBarCss(theme), hideOnMobileCss(theme)]}>
        <ProgressBar max={max} value={value} aria-describedby={id} />
      </div>

      <span id={id} css={textCss}>
        {children}
      </span>
    </div>
  )
}

LabelledProgressBar.propTypes = propTypes
